import React from 'react';
import { Navigate } from 'react-router-dom';

export const AdminPrivateRoute = ({ children }) => {
    const token = localStorage.getItem('adminAccessToken');

    return token ? children : <Navigate to="/admin/auth" replace />;
};
